export const iconFontAwesomeAlphabetE = (
	<i className="fa-solid fa-e"></i>
);
